import { Checkbox } from '@/components/checkbox/Checkbox';
import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import PasswordInput from '@/components/forms/PasswordInput';
import { Button } from '@/design-system/button';
import { Translation } from '@/hoslog-intl';
import { z } from 'zod';

const LoginSchema = z.object({
  loginId: z.string().min(1, { message: 'required' }),
  password: z.string().min(1, {
    message: 'required',
  }),
  Rememberme: z.string().optional(),
});

type LoginFormData = z.infer<typeof LoginSchema>;

interface LoginPageProps {
  handleLogin: (data: LoginFormData) => void;
  isAuthenticating: boolean;
}

export const LoginPage = ({ handleLogin, isAuthenticating }: LoginPageProps) => {
  const form = useForm({ schema: LoginSchema, mode: 'onBlur' });
  return (
    <>
      <div className=" flex h-[100vh]">
        <div className="w-1/2 bg-sidebar  justify-center items-center hidden sm:flex">
          <img className=" size-[311px]  aspect-[1/1]" src="/logo.svg" alt="" />
        </div>
        <div className="w-full sm:w-1/2 flex justify-center items-center gap-4  h-auto  bg-surface-raised">
          <div className="flex flex-col gap-4.5 w-full ">
            <div className=" font-bold">
              <div className="flex justify-center ">
                <h1 className="text-md  w-40 text-center">
                  <Translation id="login.page.form.title" />
                </h1>
              </div>
              <p className="text-foreground-caption font-normal text-xs text-center">
                <Translation id="login.page.form.subTitle" />
              </p>
            </div>

            <Form className="flex flex-col justify-center items-center  gap-4.5" form={form} onSubmit={handleLogin}>
              <div className="  flex flex-col gap-2 w-81">
                <Input className="w-full" label="login.page.form.cred.userName" {...form.register('loginId')} />
                <PasswordInput label="login.page.form.cred.password" {...form.register('password')} />
                <Checkbox color="var(--contrast)" label="login.page.form.cred.rememberMe" />
              </div>

              <Button className="w-full mt-4.5" type="submit" isLoading={isAuthenticating}>
                Login
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};
